import * as React from "react";
import {
  AlertDialogLabel,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogContent,
} from "@sparkademy/app-common/elements/Alert";
import { Box, Text } from "theme-ui";
import { Button } from "@sparkademy/app-common/elements/Button";
import { ReactComponent as IllustrationQuestion } from "@sparkademy/app-common/materials/illustrations/question.svg";
import { ButtonOutline } from "@sparkademy/app-common/elements/ButtonOutline";

export const SubmitConfirmationDialog: React.FC<{
  onClose: () => void;
  onSubmit: () => void;
}> = ({ onClose, onSubmit }) => {
  const cancelRef = React.useRef<HTMLButtonElement>();

  return (
    <AlertDialogOverlay
      id="SubmitConfirmationDialog"
      // @ts-ignore
      leastDestructiveRef={cancelRef}
    >
      <AlertDialogContent>
        <Box sx={{ maxWidth: "600px" }}>
          <AlertDialogLabel></AlertDialogLabel>
          <AlertDialogDescription>
            <Box
              sx={{
                margin: "auto",
                width: 170,
                height: 170,
                svg: {
                  width: "100%",
                  height: "auto",
                },
              }}
            >
              <IllustrationQuestion />
            </Box>
            <Text as="p" sx={{ textAlign: "center", fontWeight: 700, fontSize: "25px" }}>
              Submit for evaluation now?
            </Text>
            <Text as="p" sx={{ textAlign: "center", fontWeight: 700, fontSize: "25px" }}>
              You will not be able to change your submission after this step.
            </Text>
          </AlertDialogDescription>
        </Box>
        <Box sx={{ mt: 11 }} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "350px",
          }}
        >
          <ButtonOutline onClick={() => onClose()}>Cancel</ButtonOutline>
          <Button type="submit" onClick={() => onSubmit()}>
            Submit
          </Button>
        </Box>
      </AlertDialogContent>
    </AlertDialogOverlay>
  );
};
